import { render } from "./ClaimAttachments.vue?vue&type=template&id=6081b523"
import script from "./ClaimAttachments.vue?vue&type=script&lang=js"
export * from "./ClaimAttachments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__